import { RESOURCES_BASE } from './constants'

export interface InsidePage {
  src: string
  alt: string
}

/** Five interior pages of the product (4:5). Tracés pédagogiques. */
export const insidePages: InsidePage[] = [
  { src: RESOURCES_BASE + '1793839600709_p1-11ebd7f0.jpg', alt: 'Module 01 · Le système de conduction' },
  { src: RESOURCES_BASE + '1793839606728_p2-0e6cd8fc.jpg', alt: 'Module 02 · Lecture complète pas à pas' },
  { src: RESOURCES_BASE + '1793839612033_p3-ea2fde0e.jpg', alt: 'Module 03 · FA, flutter ou TSV ?' },
  { src: RESOURCES_BASE + '1793839617943_p4-73eef021.jpg', alt: 'Module 04 · Territoire inférieur sur 12 dérivations' },
  { src: RESOURCES_BASE + '1793839624646_p5-9a8c5bd0.jpg', alt: 'Module 06 · Cas pédagogique corrigé' },
]
